import { DealValue } from "src/app/features/prob/models/deal-value";
import { RateItem } from "src/app/features/prob/models/rate-item";

/*
* Supporting class for the deal item data changes when updating a deal item.
*/
export class DealItemDataChanges {

  /**
   * Gets or sets the deal item identifier.
   */
  dealItemId?: string | null;

  /**
   * Optional, allow client to request if they wish to remove data from the users' workspace
   * for just this deal item. Includes both rate item and deal values.
   * This is useful if the user has made changes to the deal item and wishes to clear them.
   * Note, the callers' user workspace data is automatically cleaned if requesting to save data to live (isLive set to true).
   */
  clearUserChanges?: boolean | null;

  /**
   * Gets or sets a default time segment to use if not specified in the data.
   * This is one based and by default if not specified will be set to one.
   */
  timeSegmentDefault?: number | null = 1;

  /**
   * Gets or sets the version of the model to use.
   * Will use the latest if not specified.
   */
  modelVersionOverride?: number | null = null;

  /**
   * Gets or sets the collection of Input value changes.
   */
  dealValues?: DealValue[] | null;

  /**
   * Gets or sets the blended rate item changes.
   */
  blendedRateItems?: RateItem[] | null;

  /**
   * Gets or sets the rate item changes.
   */
  rateItems?: RateItem[] | null;

  /**
   * Gets or sets the blended rate delete switch.
   */
  deleteBlendedRates?: boolean;


}
